module.exports = __webpack_public_path__ + "img/2.cedab228.png";